<template>
    <div>
        <input type="checkbox" :id="getName" class="form-inline" :name="getName" v-model="proxyValue"/>
    </div>
</template>

<script>

export default
{
    components: {},
    props: {
        column: {
            type: Object,
        },
        config: {
            type: Object,
        },
        row: {
            type: Object,
        },
    },
    data() {
        return {

        };
    },
    computed: {
        getName() {
            return this.config.name || 'name';
        },
        getValue() {
            return this.row[this.column.data];
        },
        proxyValue: {
            get() { return this.getValue; },
            set(newValue) {
                this.$emit('input', newValue);
                this.row[this.column.data] = newValue;
            }
        },
    },
    mounted() {
    },
    methods: {
    },
}
</script>

<style lang="sass">
</style>


// WEBPACK FOOTER //
// CheckboxInputColumnComponent.vue?62ce4490